import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { RouterStateUtilityService, SimpleRouterState } from '@platform-frontend/util';
import { AccountStartupService } from './account-startup.service';

export const AccountStartupGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const accountStartupService = inject(AccountStartupService);
  const routerStateUtilityService = inject(RouterStateUtilityService);

  const stateEssentials = routerStateUtilityService.getRouterStateEssentialsFromChilds(state);
  const isPageWithOwnStartupGuard = stateEssentials.data.isSignInPage || stateEssentials.data.isRegistrationCompletePage;

  if (store.selectSnapshot(SimpleRouterState.guardsActivated) && !isPageWithOwnStartupGuard) {
    accountStartupService.getStartupObservable(route.paramMap, 'OTHER').subscribe();
  }

  return true;
};
